// ナビゲーション処理
const fixNav = document.getElementById('fix-nav');
const coverImage = document.getElementById('main');
const coverImageHeight = coverImage.clientHeight;
const sections = document.querySelectorAll('#message, #events, #countdown');
const navLinks = document.querySelectorAll('#fix-nav a');
const burger = document.querySelector('.burger-menu');
const messageSection = document.getElementById('message');

function updateNav() {
    if (window.innerWidth < 769) {
        return;
    }
    let currentSection = '';
    const scrollPosition = window.scrollY + window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        const sectionHeight = section.offsetHeight;
        if (window.scrollY >= sectionTop - 1 && window.scrollY < sectionTop + sectionHeight - 1) {
            currentSection = section.getAttribute('id');
        }
    });

    // ページの一番下に到達した場合
    if (scrollPosition >= documentHeight - 1) {
        currentSection = 'rsvp';
    }

    navLinks.forEach(link => {
        link.classList.remove('active');
        if (currentSection && link.getAttribute('href').includes(currentSection)) {
            link.classList.add('active');
        }
    });

    // fixNavの表示/非表示を切り替え
    if (!fixNav){ return; }

    const coverImageBottom = coverImage ? coverImage.getBoundingClientRect().bottom + window.pageYOffset : 0;
    if (window.scrollY >= coverImageBottom) {
        fixNav.style.position = 'fixed';
        fixNav.style.top = '80px';
        fixNav.classList.add('active');
        return;
    }

    if (messageSection != null) {
        const messageSectionTop = messageSection.getBoundingClientRect().top + window.pageYOffset;
        if (window.scrollY + window.innerHeight >= messageSectionTop) {
            fixNav.classList.add('active');
            fixNav.style.position = 'absolute';
            fixNav.style.top = `${messageSectionTop + 80 }px`;
            return;
        }
    }

    fixNav.classList.remove('active');
    fixNav.style.position = '';
    fixNav.style.top = '';
    }
window.addEventListener('scroll', function() {
    updateNav();
});
window.addEventListener('resize', function() {
    updateNav();
});


burger.addEventListener('click', function () {
    fixNav.classList.toggle('open');
});
navLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
        event.preventDefault();
        fixNav.classList.remove('open');
    });
});


// イベントタイトル切り替え
const eventsEl = document.querySelector('#events');
const event02El = document.querySelector('#events .event02');

if (eventsEl && event02El) {
    eventsEl.classList.add("events");
}


// スクロールアニメーション
// v1 要素が欠けると動かない
// $(document).ready(function () {
//     // 対象セレクタ一覧
//     const selectors = ['h2', '#editor', '.events_daytime', '.events_place', '.place_others', '.count_number'];

//     // 存在する要素だけを $animationElements に追加
//     let $animationElements = $();
//     selectors.forEach(selector => {
//         const $target = $(selector);
//         if ($target.length) {
//             $animationElements = $animationElements.add($target);
//         }
//     });

// // 画面サイズに応じたオフセット
// function getOffset() {
//     return $(window).width() <= 768 ? 100 : 250;
// }

// // 要素がビューポートに入ったかチェック
// function checkIfInView() {
//     const windowHeight = $(window).height();
//     const windowBottomPosition = $(window).scrollTop() + windowHeight;

//     $animationElements.each(function () {
//     const $element = $(this);
//     const offset = $element.offset();

//     // offsetが取れない（存在しない）要素はスキップ
//     if (!offset) return;

//     const elementTopPosition = offset.top;

//     // 指定の位置に来たら.activeを付与
//     if (windowBottomPosition >= elementTopPosition + getOffset()) {
//         $element.addClass('active');
//     }
//     });
// }

// // イベント登録＆初回チェック
// $(window).on('scroll resize', checkIfInView);
// $(window).trigger('scroll');
// });



// v2 jq
//   $(document).ready(function(){
//     var target = $('h2', '#editor', '.events_daytime', '.events_place', '.place_others', '.count_number');
  
//     if (window.matchMedia( '(min-width: 481px)' ).matches) {
//       target.css('visibility','hidden');
//       $(window).scroll(function(){
//         var windowHeight = $(window).height(),
//         topWindow = $(window).scrollTop();
//       target.each(function(){
//         var objectPosition = $(this).offset().top;
//         if(topWindow > objectPosition - windowHeight + 300){
//           $(this).addClass("active");
//         }
//        });
//       });
//     }
//     else{//スマホ環境の場合
//       target.css('visibility','hidden');
//       $(window).scroll(function(){
//         var windowHeight = $(window).height(),
//         topWindow = $(window).scrollTop();
//       target.each(function(){
//         var objectPosition = $(this).offset().top;
//         if(topWindow > objectPosition - windowHeight + 150){
//           $(this).addClass("active");
//         }
//        });
//       });
//     }
//   });



// v3 jqをjsに変換
// document.addEventListener('DOMContentLoaded', function () {
//     // セレクタに該当する全ての要素を取得
//     const selectors = ['h2', '#editor', '.events_daytime', '.events_place', '.place_others', '.count_number'];
//     const targets = selectors
//     .map(sel => Array.from(document.querySelectorAll(sel)))
//     .flat();

// // 存在しない場合はスキップ
// if (targets.length === 0) return;

// // 共通：全要素の visibility を hidden にする
// targets.forEach(el => {
//     el.style.visibility = 'hidden';
// });

// // スクロールで active クラスを追加する処理
// function onScroll() {
//     const windowHeight = window.innerHeight;
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     const offset = window.matchMedia('(min-width: 481px)').matches ? 300 : 150;

//     targets.forEach(el => {
//     if (!el.offsetParent) return; // 非表示や存在しない場合にスキップ
//     const elementTop = el.getBoundingClientRect().top + scrollTop;
//     if (scrollTop > elementTop - windowHeight + offset) {
//         el.classList.add('active');
//     }
//     });
// }

// // スクロールイベント登録
// window.addEventListener('scroll', onScroll);
// });


// IntersectionObserver
window.addEventListener(
    "load",
    function () {
        function callback(entries) {
        for (let i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
            entries[i].target.classList.add("is-active");
            }
        }
    }

    let options = {
    root: null,
    rootMargin: "-40% 0px",
    threshold: 0.0,
    };

    let observer = new IntersectionObserver(callback, options);

    var editor = document.querySelectorAll(".message_inner_text_wrap");
    var events = document.querySelector("#events");
    var messageTtl = document.querySelector("#message h2");
    var eventsTtl = document.querySelector("#events h2");
    var countdownTtl = document.querySelector("#countdown h2");
    var eventsDaytime = document.querySelectorAll(".events_daytime");
    var eventsPlace = document.querySelectorAll(".events_place");
    var placeOthers = document.querySelectorAll('.place_others');
    var countdown = document.querySelector(".count_number");
    let observeropcity = function () {
        if (messageTtl) {
            observer.observe(messageTtl);
        } else {
            observer.observe(events);      
        }

        if(editor != null){
            for (let i = 0; i < editor.length; i++){
                if(editor[i] != null){
                    observer.observe(editor[i]);
                }
            }
        }

        observer.observe(eventsTtl);
        observer.observe(events);
        for (let i = 0; i < eventsDaytime.length; i++){
            if(eventsDaytime[i] != null){
                observer.observe(eventsDaytime[i]);
            }
        }
        for (let i = 0; i < eventsPlace.length; i++){
            if(eventsPlace[i] != null){
                observer.observe(eventsPlace[i]);
            }
        }
        for (let i = 0; i < placeOthers.length; i++){
            if(placeOthers[i]!= null){
                observer.observe(placeOthers[i]);
            }
        }
        if(countdown != null){
            observer.observe(countdownTtl);
            observer.observe(countdown);
        }
    };
    observeropcity()
},
false
);
